import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/2.jpg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonNeftissov = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Нефтисов Александр Витальевич</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>доктор PhD, ассоциированный профессор</MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=58127024800'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-4079-2025'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», директор НИЦ «Industry 4.0»<br /><b>Стаж по профилю 14 лет</b></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Научный руководитель</MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Имеет опыт работы в сфере высшего и послевузовского образования, эксперт в создании информационно-аналитических систем, математическом моделировании, имеет задел по теме проекта. Есть экспертиза в области построения интеллектуальных систем построения рейтингов на основе зависимых индикаторов.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Научный руководитель — BR24993128 «Разработка информационно-аналитической системы для принятия решений для эффективного использования трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона».
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ответственный исполнитель — BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий».
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Научный руководитель — AP13067967, AP19678730, AP19678773 и другие гранты.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации по теме проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Neftissov et al. Analysis of the Existing Air Emissions Detection Methods. Applied Sciences, 2024. DOI 10.3390/app142310934 [Scopus Q1]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Zhalmagambetova et al. Implications of Water Quality Index. Water, 2024. DOI 10.3390/w16152203 [Scopus Q1]
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    3. Biloshchytskyi et al. Fractal Analysis of Air Pollution Time Series. Urban Science, 2024. [Scopus Q1]
                </MyText>
            </Flex>
        </Flex>
    );
};
